import { dateFormatter } from './func';

export default {
  primary(msg: string) {
    console.log(`%c${dateFormatter()}: %c Ktracker `, 'color:#999', 'background:#1a7afb;color:#fff', msg);
  },

  info(msg: string) {
    console.log(`%c${dateFormatter()}: %c Ktracker `, 'color:#999', 'background:#909399;color:#fff', msg);
  },

  warn(msg: string) {
    console.log(`%c${dateFormatter()}: %c Ktracker `, 'color:#999', 'background:#faad14;color:#fff', msg);
  },

  error(msg: string) {
    console.log(`%c${dateFormatter()}: %c Ktracker `, 'color:#999', 'background:#f5222d;color:#fff', msg);
  },

  success(msg: string) {
    console.log(`%c${dateFormatter()}: %c Ktracker `, 'color:#999', 'background:#67C23A;color:#fff', msg);
  },
};
